import {lazy} from '@aboutyou/lazy-imports';
import {Drawer, ErrorBoundary} from '@aboutyou/ui-components';
import React, {memo} from 'react';

const WalletLogicComponent = lazy(() =>
  import('@aboutyou/logic-components/src/backend-services/Wallet/Wallet').then(
    mod => ({
      default: mod.Wallet,
    }),
  ),
);

const CoinsHistory = lazy(() =>
  import(
    '@aboutyou/logic-components/src/features/Coins/CoinsHistory/CoinsHistory'
  ).then(mod => ({
    default: mod.CoinsHistory,
  })),
);

const CouponAddToBasket = lazy(() =>
  import(
    '@aboutyou/logic-components/src/features/Coupons/CouponWallet/CouponAddToBasket/CouponAddToBasket'
  ).then(mod => ({
    default: mod.CouponAddToBasket,
  })),
);

const WalletAddToBasketMemo = memo(CouponAddToBasket);
const WalletLogicComponentMemo = memo(WalletLogicComponent);
const CoinsHistoryMemo = memo(CoinsHistory);

export const Wallet = () => {
  return (
    <ErrorBoundary renderContext="couponWallet" ErrorComponent={null}>
      <WalletLogicComponentMemo ContentPopperLayoutComponent={Drawer} />
      <CoinsHistoryMemo ContentPopperLayoutComponent={Drawer} />
      <WalletAddToBasketMemo renderMiniADP />
    </ErrorBoundary>
  );
};
